import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { LocalRepository } from "@shared/helper/local-repository";
import { HttpBaseService } from "@shared/service/base_services/http_base.service";
import { IClubModel } from "@app/pages/clubs/models/club-model";
import { Observable } from "rxjs";
import { TServiceResult } from "@shared/helper/t-service-result";
import { IClubMeetingModel } from "@app/pages/clubs/models/club-meeting-model";
import {IClubCourseModel} from "@app/pages/clubs/models/club-course-model";
import {IClubPollModel} from "@app/pages/clubs/models/club-poll-model";
import {PageList} from "@shared/model/categoryAndSearch/pageList-model";

@Injectable({
    providedIn: 'root'
})
export class ClubService extends HttpBaseService {
    constructor() {
        const repo = inject(LocalRepository);
        const http = inject(HttpClient);

        super(repo, http, 'clb');
    }

    get(clubId: string): Observable<TServiceResult<IClubModel>> {
        return this.http.get<TServiceResult<IClubModel>>(`${this.apiUrl}/${clubId}`);
    }

    getJoinedClubs(): Observable<TServiceResult<PageList<IClubModel>>> {
      return this.http.get<TServiceResult<PageList<IClubModel>>>(`${this.apiUrl}/Joined`);
    }

    create(club: IClubModel): Observable<TServiceResult<string>> {
        return this.http.post<TServiceResult<string>>(`${this.apiUrl}`, club);
    }

    update(clubId: string, club: IClubModel): Observable<TServiceResult<string>> {
        return this.http.put<TServiceResult<string>>(`${this.apiUrl}/${clubId}`, club);
    }

    revoke(clubId: string): Observable<TServiceResult<any>> {
        return this.http.patch<TServiceResult<any>>(`${this.apiUrl}/${clubId}/Revoke`, {});
    }

    addMember(clubId: string, userId: string): Observable<TServiceResult<any>> {
      return this.http.post<TServiceResult<any>>(`${this.apiUrl}/${clubId}/members`, {userId});
    }

    join(clubId: string): Observable<TServiceResult<any>> {
        return this.http.post<TServiceResult<any>>(`${this.apiUrl}/${clubId}/Join`, {});
    }

    createMeeting(clubId: string, meeting: IClubMeetingModel): Observable<TServiceResult<string>> {
        return this.http.post<TServiceResult<string>>(`${this.apiUrl}/${clubId}/Meetings`, meeting);
    }

    createCourse(clubId: string, course: IClubCourseModel): Observable<TServiceResult<string>> {
      return this.http.post<TServiceResult<string>>(`${this.apiUrl}/${clubId}/Courses`, course);
    }

    createPastCourse(clubId: string, course: IClubCourseModel): Observable<TServiceResult<any>> {
      return this.http.post<TServiceResult<any>>(`${this.apiUrl}/${clubId}/Courses/past`, course);
    }

    createPoll(clubId: string, poll: IClubPollModel): Observable<TServiceResult<string>> {
      return this.http.post<TServiceResult<string>>(`${this.apiUrl}/${clubId}/Polls`, poll);
    }

    removeClubMember(clubId: string, userId: string): Observable<TServiceResult<string>> {
        return this.http.delete<TServiceResult<string>>(`${this.apiUrl}/${clubId}/members/${userId}`);
    }

    deactivateClub(clubId: string): Observable<TServiceResult<any>> {
      return this.http.patch<TServiceResult<any>>(`${this.apiUrl}/Dactive?clubId=${clubId}`, {});
    }
}
